import { render } from "./EnhancedPlansDashboard.vue?vue&type=template&id=227ed730&scoped=true"
import script from "./EnhancedPlansDashboard.vue?vue&type=script&lang=js"
export * from "./EnhancedPlansDashboard.vue?vue&type=script&lang=js"

import "./EnhancedPlansDashboard.vue?vue&type=style&index=0&id=227ed730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227ed730"]])

export default __exports__